import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/**
 * Service for querying DOM elements
 */
@Injectable()
export class DomQueryService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  /**
   * Returns an HTMLElement using the querySelector method for the selector passed as a parameter
   *
   * @param selector - CSS selector string
   * @returns The first HTMLElement that matches the selector, or null if no element is found
   */
  public querySelector(selector: string): HTMLElement | HTMLScriptElement | null {
    return this.document.querySelector(selector);
  }

  /**
   * Returns all HTMLElements using the querySelectorAll method for the selector passed as a parameter
   *
   * @param selector - CSS selector string
   * @returns A NodeList of all HTMLElements that match the selector
   */
  public querySelectorAll(selector: string): NodeListOf<HTMLElement> {
    return this.document.querySelectorAll(selector);
  }
}
